import {
    MILITARY_VARIANT,
    STC_VARIANT,
    isMilitaryEnabled,
    refs,
} from "../../Database/_variants/index.js";
import members, {
    customerDesignChangesAttachable,
    customerMilitaryDesignChangesAttachable,
} from "../../Home/CustomerManager/attachable.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";
import { addCustomer } from "../../Home/CustomerManager/actions.js";

const customerDesignChangeAttachables = [
    customerDesignChangesAttachable,
    isMilitaryEnabled() ? customerMilitaryDesignChangesAttachable : null,
].filter(Boolean);

const defaultTableSettings = {
    columnState: [{
        headerName: "Name",
        field: "Name",
        minWidth: 240,
        flex: 1
    }, {
        headerName: "Has Account",
        field: "HasAccount",
        type: "bool",
        width: 140
    }, {
        headerName: "Members",
        field: "MemberCount",
        type: "number",
        width: 120
    }]
};

const applicationAdminLock = user => [
    user?.Security?.General?.ApplicationAdmin !== true,
    "Application administrator access is required"
];

export default [{
    "path": "/Admin/Customers",
    "component": { ...ItemListView },
    "name": "Customers",
    "meta": {
        "app": "Admin",
        "sideNav": true,
        "name": "Customers",
        "sideNavSection": "Admin",
        "sideNavPosition": 2,
        "appSwitcher": false,
        "tableSettings": "CustomerAccounts",
        defaultTableSettings,
        "persistTableSettings": false,
        "dataPath": "Database/Customers",
        "selectionRoute": "Admin/Customers/{ID}",
        "applyDesignChangeFilter": false,
        "addToRecents": false,
        "listFilters": {
            "default": "with-account",
            "options": [{
                "label": "With Account",
                "value": "with-account",
                filter: customer => customer.HasAccount
            }, {
                "label": "All Customers",
                "value": "all",
                filter: () => true
            }]
        },
        map(customer) {
            const memberCount = Object.keys(customer.Members || {}).length;
            return { ...customer, MemberCount: memberCount, HasAccount: memberCount > 0 };
        },
        "lock": applicationAdminLock,
        hidden(user) {
            return user?.Security?.General?.ApplicationAdmin !== true;
        },
        "menuActions": [{
            "label": "Add Customer",
            "action": addCustomer
        }]
    }
}, {
    "path": "/Admin/Customers/:id",
    "component": ItemView,
    "name": "Customer",
    "meta": {
        "app": "Admin",
        "sideNav": false,
        "appSwitcher": false,
        "dataPathOverride": "Database/Customers/:id",
        linkedDataWatchLocations({ store }) {
            const locations = [];
            if (store.state.user?.Security?.Database?.Read === true) {
                locations.push(refs(STC_VARIANT, "DesignChanges"));
            }
            if (isMilitaryEnabled() && store.state.user?.Security?.Military?.Read === true) {
                locations.push(refs(MILITARY_VARIANT, "DesignChanges"));
            }
            return locations;
        },
        title(item) {
            return `Customer: ${item.Name}`;
        },
        "dataFields": [{
            "label": "Name",
            "key": "Name"
        }, {
            "label": "Members",
            compute({ item }) {
                return Object.keys(item.Members || {}).length;
            }
        }],
        "attachedItems": {
            "Members": { "attachables": [members] },
            "Design Changes": { "attachables": customerDesignChangeAttachables }
        },
        "lock": applicationAdminLock,
        "menuActions": []
    }
}];
